@if (displayDrawer()) {
  <div class="account-info-drawer">
    <!-- EXT-6537: header and tabs pin together, so the tabs no longer need a
         hard-coded offset under a header whose height can change. -->
    <div class="drawer-chrome">
      <header class="header">
        <div class="header-title">
          <span class="header-name"
            >{{ platformAccount()?.accountNumber }} ·
            {{ platformAccount()?.accountName }}</span
          >
        </div>
        <button mat-icon-button aria-label="Close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <nav class="tabs">
        <button
          class="tab"
          [class.active]="drawerState() === 'account'"
          (click)="setTab('account')"
        >
          Account
        </button>
        <button
          class="tab"
          [class.active]="drawerState() === 'shipping'"
          (click)="setTab('shipping')"
        >
          Shipping
        </button>
        <button
          class="tab"
          [class.active]="drawerState() === 'comments'"
          (click)="setTab('comments')"
        >
          Comments
        </button>
      </nav>
    </div>

    @if (drawerState() === "account") {
      <app-account-store-info></app-account-store-info>
    }
    @if (drawerState() === "shipping") {
      <app-shipping-info></app-shipping-info>
    }
    @if (drawerState() === "comments") {
      <app-comments></app-comments>
    }
  </div>
}
